import { render, staticRenderFns } from "./CardSvgLarge.vue?vue&type=template&id=255511b5&"
import script from "./CardSvgLarge.vue?vue&type=script&lang=js&"
export * from "./CardSvgLarge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports